import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=e8e4c61a&scoped=true&"
import script from "./HomeAbout.vue?vue&type=script&lang=js&"
export * from "./HomeAbout.vue?vue&type=script&lang=js&"
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=e8e4c61a&lang=scss&scoped=true&"
import style1 from "./HomeAbout.vue?vue&type=style&index=1&id=e8e4c61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e4c61a",
  null
  
)

export default component.exports